export const Section = ({ id, eyebrow, title, action, children, className = "" }) => (
  <section id={id} data-testid={`section-${id}`} className={`space-y-6 ${className}`}>
    <div className="flex flex-wrap items-end justify-between gap-3 border-b border-slate-800 pb-3">
      <div>
        {eyebrow && <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-sky-400 mb-1">{eyebrow}</p>}
        <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-100">{title}</h2>
      </div>
      {action}
    </div>
    {children}
  </section>
);
